import { featureItems } from '@/mocks/homepage';

export default function Features() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            为什么选择91视频网站
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            用心打造每一个观影细节，让您的每一次观看都成为享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${item.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}